import React, { useState } from "react";
import CreateSKU from "../Sku/CreateSKU";
import SkuListing from "../Sku/SkuListing";
import { toast } from "../../../components/AppToast";
import { createItemAPI } from "../../../services/skuItem/skuItem";
import { updateItemAPI } from "../../../services/skuItem/skuItem";

export default function SKUManagement() {
  const [isCreating, setIsCreating] = useState(false);
  const [activeRecord, setActiveRecord] = useState(null); // view / edit
  const [listVersion, setListVersion] = useState(0);
  const onlyFormVisible = isCreating || !!activeRecord;

  const closeForm = () => {
    setIsCreating(false);
    setActiveRecord(null);
  };

  const submitForm = async (formData, id) => {
    try {
      if (id) {
        await updateItemAPI(formData, id);
      } else {
        await createItemAPI(formData);
      }

      closeForm();
      setListVersion((v) => v + 1);
    } catch (err) {
      toast.error("Operation failed");
      console.error(err);
    }
  };

  return (
    <div className="card shadow-lg main-card">
      {/* ---------- HEADER ---------- */}
      <div className="card-header bg-secondary text-white d-flex justify-content-between align-items-center">
        <h4 className="mb-0 h6 fw-semibold">
          {!onlyFormVisible
            ? "Item / SKU Management"
            : isCreating
            ? "Create Item"
            : activeRecord?.mode === "edit"
            ? "Edit Item"
            : "View Item"}
        </h4>
      </div>

      {/* ---------- BREADCRUMBS ---------- */}
      {onlyFormVisible && (
        <nav
          aria-label="breadcrumb"
          className="px-3 py-2 border-bottom bg-light"
        >
          <ol
            className="breadcrumb mb-0 align-items-center"
            style={{ ["--bs-breadcrumb-divider"]: "'/'" }}
          >
            <li className="breadcrumb-item">
              <button
                type="button"
                className="btn btn-link p-0 text-decoration-none text-muted"
                onClick={closeForm}
              >
                Item / SKU Management
              </button>
            </li>

            <li
              className="breadcrumb-item active fw-semibold text-primary"
              aria-current="page"
            >
              {isCreating
                ? "Create Item"
                : activeRecord?.mode === "edit"
                ? "Edit Item"
                : "View Item"}
            </li>
          </ol>
        </nav>
      )}

      {/* ---------- BODY ---------- */}
      <div className="card-body">
        {!onlyFormVisible ? (
          <SkuListing
            refreshKey={listVersion}
            onCreateClick={() => setIsCreating(true)}
            onView={(row) =>
              setActiveRecord({ mode: "view", data: row })
            }
            onEdit={(row) =>
              setActiveRecord({ mode: "edit", data: row })
            }
          />
        ) : (
          <CreateSKU
            initialValues={activeRecord?.data || {}}
            onCancel={closeForm}
            onSubmit={submitForm}
            viewOnly={activeRecord?.mode === "view"}
            isEdit={activeRecord?.mode === "edit"}
          />
        )}
      </div>
    </div>
  );
}
